<template>
  <MainLayout>
    <template #sidebar-top>
      <div class="pa-4 d-flex flex-column align-center">
        <v-row no-gutters>
          <v-col cols=12 md=12 class="mb-2">
            <v-btn block elevation="0"  @click="$route.name !== 'new' && newProject()">
              <v-icon>mdi-file-plus-outline</v-icon>
              <span class="text-none">Nouveau</span>
            </v-btn>
          </v-col>
          <v-col cols=12 md=12>
            <v-btn block elevation="0" @click="dialog = true">
              <v-icon>mdi-magnify</v-icon>
              <span class="text-none">Recherche</span>
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <SearchDialog v-model="dialog" />
    </template>

    <template #sidebar-conversations>
      <div
        class="sidebar-section-header overline pl-4 pr-2 mt-4 d-flex align-center justify-space-between"
        @click="projectsOpen = !projectsOpen"
        style="cursor:pointer"
      >
        <span>
          <v-icon small class="pb-1">mdi-hammer-wrench</v-icon>
          Chantiers
        </span>
        <v-icon small>{{ projectsOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </div>
      <project-list
        v-show="projectsOpen"
        :projects="projects"
        :current-id="currentConversationId"
      />

      <div
        class="sidebar-section-header overline pl-4 pr-2 mt-2 d-flex align-center justify-space-between"
        @click="conversationsOpen = !conversationsOpen"
        style="cursor:pointer"
      >
        <span>
          <v-icon small class="pb-1">mdi-chat-outline</v-icon>
          Conversations</span>
        <v-icon small>{{ conversationsOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </div>
      <conversation-list
        v-show="conversationsOpen"
        :conversations="sortedConversations"
        :current-conversation-id="currentConversationId"
      />
    </template>

    <template #header>
      <slot name="header" />
    </template>

    <template #content>
      <slot name="content" />
    </template>
  </MainLayout>
</template>

<script>
import MainLayout from './MainLayout.vue'
import ConversationList from '@/components/conversations/ConversationList.vue'
import ProjectList from '@/components/conversations/ProjectList.vue'
import SearchDialog from '@/components/ui/SearchDialog.vue'

export default {
  name: 'ChatLayout',
  components: { MainLayout, ConversationList, ProjectList, SearchDialog },
  data() {
    return {
      dialog: false,
      projectsOpen: true,
      conversationsOpen: true,
    }
  },
  computed: {
    projects() {
      return this.$store.state.project.projects
    },
    sortedConversations() {
      return this.$store.state.chat.conversations.slice().sort((a, b) => b.updated_at > a.updated_at ? 1 : -1)
    },
    currentConversationId() {
      return this.$route.params.id || null
    },
  },
  mounted() {
    this.$store.dispatch('project/loadProjects')
    this.$store.dispatch('chat/initConversations')
    window.addEventListener('keydown', this.handleGlobalKeydown)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleGlobalKeydown)
  },
  methods: {
    newDiscussion() {
      this.$store.dispatch('chat/newConversation')
      this.$router.push({ name: 'home' })
    },
    newProject() {
      this.$store.dispatch('chat/newConversation')
      this.$router.push({ name: 'new' })
    },
    handleGlobalKeydown(event) {
      if (event.altKey && event.key.toLowerCase() === 'n') {
        event.preventDefault()
        if (this.$route.name !== 'new') this.newProject()
      } else if (event.altKey && event.key.toLowerCase() === 'f') {
        event.preventDefault()
        this.dialog = !this.dialog
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.sidebar-section-header {
  user-select: none;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  color: var(--app-text-muted, rgba(0,0,0,0.5));
  &:hover { color: var(--app-text-strong, rgba(0,0,0,0.8)); }

  .theme--dark & {
    color: var(--app-text-muted-on-dark, rgba(255,255,255,0.4));
    &:hover { color: rgba(255,255,255,0.7); }
  }
}
</style>
